import { Component, OnDestroy, OnInit } from '@angular/core';
import { ColCatService } from '../../services/col-cat.service';
import { Observable, Subscription } from 'rxjs';
import { ProductSelectorService } from '../product-selector.service';

@Component({
  selector: 'app-product-selector',
  templateUrl: './product-selector.component.html',
  styleUrls: ['./product-selector.component.scss']
})

export class ProductSelectorComponent implements OnDestroy, OnInit {

  private subCategories: any[];
  private subscription: Subscription;

  public products: Observable<any[]>;
  public selectedProducts: Observable<any> = null;

  constructor(
    private colCatService: ColCatService,
    private productSelector: ProductSelectorService
  ) {}

  ngOnInit(): void {
    this.subscription = this.colCatService.subCategory().subscribe(data => this.subCategories = data);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public onChange(product): void {
    this.productSelector.selectedProduct = product;
  }
}
